import React from 'react';
import { Provider } from 'react-redux';
import { store } from './app/store';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom-bootstrap.scss';
import reportWebVitals from './reportWebVitals';
import './polyfills/randomUUID';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Uncomment the following line to enable React Strict Mode and remove the surrounding <></> tags
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
